import LanguagesService from '@/api/admin/languages.service'

export default {
  state: {
    tableResources: {
      pageLength: 10,
      columns: [
        {
          field: 'resourceName',
        },
      ],
      rows: [],
      totalRecords: 0,
      searchTerm: '',
      isEditing: false,
      model: {},
    },
  },
  getters: {
    getlanguagesResources: state => state.tableResources,
    getlanguagesModel: state => state.model,
    isEditingResource: state => state.tableResources.isEditing,
  },
  actions: {
    async translate({ commit }, requestObject) {
      const translated = await LanguagesService.translate(requestObject.id, requestObject.filter ?? {})
      commit('SET_TABLE_RESOURCES', translated)
      commit('SET_TRANSLATE_MODEL', translated)
      commit('SET_EDITING_RESOURCE', false)
    },
  },
  mutations: {
    SET_EDITING_RESOURCE(state, isEditing) {
      state.tableResources.isEditing = isEditing
    },
    SET_TABLE_RESOURCES(state, translated) {
      state.tableResources.rows = translated.languageResources.map(item => ({ item }))
      if (state.tableResources.columns.length !== translated.languages.length + 1) {
        state.tableResources.columns = state.tableResources.columns.concat(translated.languages.map(l => ({
          label: l.name,
          field: l.id,
          flag: `${l.uniqueSeoCode}`,
          width: '350px',
        })))
      }
      state.tableResources.totalRecords = translated.totalRecords
    },
    SET_TRANSLATE_MODEL(state, response) {
      state.model = response
    },
  },
}
